import cn from "classnames";
import { ReactNode } from "react";

import styles from "@platformAssets/components/Chip.module.scss";

type Props = {
  children?: ReactNode;
  customClass?: string;
  isActive?: boolean;
  isDisabled?: boolean;
  readonly?: boolean;
  multiple?: boolean;
  bio?: boolean;
  strokeIcon?: boolean;
  onClick?: (arg: React.MouseEvent<HTMLDivElement>) => void;
};

const Chip = ({
  isActive,
  isDisabled,
  onClick,
  children,
  customClass,
  readonly = false,
  multiple = false,
  bio = false,
  strokeIcon = false,
}: Props) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        styles.chip,
        {
          [styles.selected]: isActive,
          [styles.disabled]: isDisabled,
          [styles.readonly]: readonly,
          [styles.withRadioBtn]: !readonly && !multiple,
          [styles.bio]: readonly && bio,
          [styles.strokeIcon]: bio && strokeIcon,
        },
        customClass
      )}
    >
      {!readonly && !multiple && <div className={styles.radioBtn} />}

      <div className={styles.text}>{children}</div>
    </div>
  );
};

export { Chip };
